





























import AuthenticationService from '@/auth.service';
import { Component, Vue } from 'vue-property-decorator';
import { RawLocation } from 'vue-router';

@Component
export default class Login extends Vue {
  public loginData: any = {};
  public sendingRequest = false;

  public get expiredSession(): boolean {
    const expiredSessionParam = this.$router.currentRoute.query.expired_session;

    return expiredSessionParam === '1';
  }

  public get redirectLocation(): RawLocation {
    const redirectParam = this.$router.currentRoute.query.redirect;

    if (!redirectParam) {
      return { name: 'home' };
    }

    return redirectParam as string;
  }

  public async onSubmit(): Promise<void> {
    this.sendingRequest = true;
    try {
      await AuthenticationService.login(this.loginData);
      this.$router.replace(this.redirectLocation);
    } catch (e) {
      console.error(e);
      this.$buefy.snackbar.open({
        message: 'Erreur d\'authentification',
        type: 'is-danger',
      });
    }
    this.sendingRequest = false;
  }
}
